<script setup lang="ts">
import { ref, watch, computed, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{ modelValue?: string }>()
const emit = defineEmits(['change', 'update:value', 'update:modelValue'])
const { t } = useI18n()

const options = computed(() => [
  { label: t('settings.pos.general_settings.cds.font_size.xs'), value: '0.75rem' },
  { label: t('settings.pos.general_settings.cds.font_size.normal'), value: '0.875rem' },
  { label: t('settings.pos.general_settings.cds.font_size.medium'), value: '1rem' },
  { label: t('settings.pos.general_settings.cds.font_size.large'), value: '1.5rem' },
  { label: t('settings.pos.general_settings.cds.font_size.x_large'), value: '2rem' },
])

// pure number → append rem; number+rem → keep; anything else → invalid
const normalize = (v: string): string | null => {
  const s = v?.trim()
  if (/^\d+(\.\d+)?$/.test(s)) return s + 'rem'
  if (/^\d+(\.\d+)?rem$/.test(s)) return s
  return null
}

const currentValue = ref(props.modelValue || '')
watch(() => props.modelValue, v => { if (v !== undefined) currentValue.value = v })

const handleChange = (val: string) => {
  const normalized = normalize(val)
  if (!normalized) {
    // revert to last valid value
    nextTick(() => { currentValue.value = props.modelValue || '' })
    return
  }
  currentValue.value = normalized
  emit('change', normalized)
  emit('update:value', normalized)
  emit('update:modelValue', normalized)
}
</script>

<template>
  <el-select v-model="currentValue" filterable allow-create @change="handleChange" class="w-full">
    <el-option v-for="opt in options" :key="opt.value" :label="`${opt.label} (${opt.value})`" :value="opt.value" />
  </el-select>
</template>
